import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { GridModule } from '../grid/grid.component.module';
import { RelatedSitesDialogComponent } from './related-sites-dialog.component';

@NgModule({
    declarations: [RelatedSitesDialogComponent],
    imports: [CommonModule, TwcModule, TranslateModule, ReactiveFormsModule, GridModule],
    exports: [RelatedSitesDialogComponent],
})
export class RelatedSitesDialogModule {}
